import { UgcPlayer } from './UgcPlayer';

const Star = (): JSX.Element => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7z" />
  </svg>
);

/**
 * Right-pane proof content (desktop only). Sits above the proof-pane glow orbs.
 * Stat row + rotating UGC player + caption.
 */
export const ProofPanel = (): JSX.Element => {
  return (
    <div className="relative z-[2] flex w-full max-w-[520px] flex-col gap-[26px]">
      {/* Stat row */}
      <div className="flex items-center justify-center gap-[14px]">
        <div className="flex gap-[2px]" style={{ color: '#f9ae3b' }}>
          <Star />
          <Star />
          <Star />
          <Star />
          <Star />
        </div>
        <span className="text-[14px] font-medium" style={{ color: '#dfe6f2' }}>
          <b className="font-bold text-white">8,000+ brands</b> make their ads here
        </span>
      </div>

      {/* Rotating player */}
      <UgcPlayer />

      {/* Caption */}
      <p className="text-center text-[13px] font-medium leading-[1.5]" style={{ color: '#cfd6e4' }}>
        <b className="font-bold text-white">Real ads our users made — on loop.</b>
        <br />
        Yours are minutes away. No camera, no crew, no editing.
      </p>
    </div>
  );
};
